import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(sp.get("token") || "");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset — please log in.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Reset failed"); }
    finally { setLoading(false); }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="glass rounded-3xl p-8">
          <div className="inline-flex rounded-full bg-lime text-bg px-3 py-1 font-mono text-[10px] uppercase tracking-widest mb-4">Reset Password</div>
          <h1 className="font-display text-4xl uppercase leading-[0.9]">New password. <span className="grad-text">Fresh start.</span></h1>
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input required data-testid="rp-token" value={token} onChange={(e) => setToken(e.target.value)} placeholder="Reset token" className="input-dark font-mono text-xs" />
            <input required data-testid="rp-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 6 chars)" className="input-dark" minLength={6} />
            <button data-testid="rp-submit" disabled={loading} className="btn-primary w-full justify-center"><KeyRound className="w-4 h-4" /> {loading ? "Resetting..." : "Reset Password"}</button>
          </form>
          <div className="mt-6 text-sm font-mono text-muted"><Link to="/login" className="text-lime underline">Back to login</Link></div>
        </div>
      </div>
    </Layout>
  );
}
